import { useCallback } from 'react';
import { useBlockEditFormStore } from '@ContractBuilder/modules/block-edit';
import { INLINE_BLOCK_EDITOR_NAME, useEditorsMap } from '@providers/editors-map';

import type { ClauseDocxImportOutcome } from '../types';

export const useReplaceClauseContentOutcome = (): ClauseDocxImportOutcome => {
  const { getEditor } = useEditorsMap();
  const setFormValues = useBlockEditFormStore(({ setFormValues }) => setFormValues);
  const targetBlockId = useBlockEditFormStore(({ formValues }) => formValues?.id);
  const targetEditor = getEditor(INLINE_BLOCK_EDITOR_NAME);

  return useCallback(
    ({ html }) => {
      const currentBlockId = useBlockEditFormStore.getState().formValues?.id;
      const currentEditor = getEditor(INLINE_BLOCK_EDITOR_NAME);

      if (!targetEditor || !currentEditor || currentEditor !== targetEditor || currentBlockId !== targetBlockId) {
        return 'cancelled';
      }

      targetEditor.chain().setContent(html, true).focus('end').run();
      setFormValues((formValues) => ({ ...formValues, last_imported_at: new Date().toISOString() }));
      return 'applied';
    },
    [getEditor, setFormValues, targetBlockId, targetEditor],
  );
};
